/* import __COLOCATED_TEMPLATE__ from './issue.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();